import { Box, Drawer, IconButton, Typography } from "@mui/material";
import { CloseIcon } from "../../../assets/icons";

const DefaultDrawer = ({
  anchor = "right",
  title,
  isOpen,
  onClose,
  showCloseButton = true,
  children,
  customStyles,
}) => {
  return (
    <Drawer
      anchor={anchor}
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        sx: { ...customStyles },
      }}
    >
      <Box
        position="sticky"
        top={0}
        zIndex={100}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        backgroundColor="#202338"
        color="#FFF"
        p="16px 24px"
        sx={{
          position: "sticky",
          top: 0,
        }}
      >
        <Typography fontWeight={600} fontSize="20px">
          {title}
        </Typography>
        <IconButton
          aria-label="close-drawer"
          onClick={onClose}
          sx={{ visibility: showCloseButton ? "visible" : "hidden" }}
        >
          <CloseIcon color="#FFF" />
        </IconButton>
      </Box>
      {children}
    </Drawer>
  );
};

export default DefaultDrawer;
